import React from 'react';

import { Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon, Translate, NotificationBanner } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(4)
  },
  link: {
    cursor: 'pointer'
  }
}));

export default function BannerOutdatedCrits ({
  handleOpen
}: {
  handleOpen: () => void
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <NotificationBanner
        variant='outlined'
        severity='warning'
        icon={
          <Icon type='outdated' color='warning' />
        }
        title={
          <>
            <Translate content='review_outdated_criteria_text' />
            {' '}
            <Link
              className={classes.link}
              rel='nofollow noreferrer noopener'
              target='_blank'
              onClick={handleOpen}
            >
              <Translate content='review_outdated_criteria_link' />
            </Link>
          </>
        }
      />
    </div>
  );
}
